module.exports = __webpack_public_path__ + "static/media/bhuv.cde6f05d.jfif";